var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leco-page-wrapper",attrs:{"id":"leco-app"}},[_c('LecoHeader'),_c('router-view'),_c('LecoFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }